import { render, staticRenderFns } from "./StatoBinari.vue?vue&type=template&id=fd6c4756&"
import script from "./StatoBinari.vue?vue&type=script&lang=js&"
export * from "./StatoBinari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports